import { setCookie } from 'cookies-next'
import { useCurrentLocale } from 'next-i18n-router/client'
import { usePathname, useRouter } from 'next/navigation'
import { useCallback } from 'react'
import { getLocalePath } from './getLocalePath'
import { i18n } from './i18n-config'

export const useLocale = () => {
  const currentLocale = useCurrentLocale(i18n)
  const router = useRouter()
  const currentPathname = usePathname()

  const setLocale = useCallback(
    (locale: string) => {
      const expired = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)
      setCookie(i18n.localeCookie, locale, { expires: expired, path: '/' })

      if (currentLocale === i18n.defaultLocale && !i18n.prefixDefault) {
        router.push(`/${locale}${currentPathname}`)
      } else {
        router.push(currentPathname.replace(`/${currentLocale}`, `/${locale}`))
      }

      router.refresh()
    },
    [currentLocale, currentPathname, router],
  )

  return {
    path: getLocalePath(currentLocale),
    locale: currentLocale,
    setLocale,
  }
}
